module.exports = ".field {\r\n    display: inline-block;\r\n    margin-right: 60px;\r\n}"